export const removeSmsItem = (menuElements: MenuItem[]): MenuItem[] =>
  menuElements.filter((item) => item.label !== 'SMS');
